<template lang="pug">
v-data-table(
  :headers='headers',
  :items='websites',
  :expand='true',
  item-key='id',
  :pagination.sync='pagination',
  :search='$store.state.filters.search',
  :loading='isLoading',
  :must-sort='true',
  :rows-per-page-items='[10, 50]'
  )

  template(slot='items', slot-scope='props')
    tr
      td(style='width: 20px;padding: 0 0 0 20px')
        v-tooltip(right)
          v-icon(color='orange', v-if='props.item.state === "testmode"', slot='activator') fa fa-exclamation-triangle
          | Test-modus

        v-tooltip(right)
          v-icon(color='error', v-if='props.item.state === "disabled"', slot='activator') fa fa-ban
          | Uitgeschakeld

        //- v-tooltip(right)
          v-icon(color='green', v-if='props.item.state === "enabled"', slot='activator') fa fa-check
          | Ingeschakeld

      td {{ props.item.createdAt | date }}
      td {{ props.item.domain }}
      td.text-xs-right
        options
          v-list-tile(:to='{ name: "website details", params: { websiteId: props.item.id } }')
            v-icon fa fa-cog
            | Bewerken
          v-divider
          v-list-tile(@click='deleteWebsite(props.item)')
            v-icon(color='red darken-2') fa fa-trash-alt
            | Verwijderen
</template>

<script>
export default {
  props: {
    value: Array,
    loading: Boolean
  },

  components: {
    Options: require('@/components/Table/Options').default
  },

  data () {
    return {
      isLoading: this.loading,
      websites: this.value,

      headers: [
        {
          text: null,
          sortable: true,
          value: 'state'
        },
        {
          text: 'Aangemaakt',
          sortable: true,
          value: 'createdAt'
        },
        {
          text: 'Domein',
          sortable: true,
          value: 'domain'
        },
        {
          text: '',
          sortable: false
        }
      ],

      pagination: {
        sortBy: 'createdAt',
        descending: true
      }
    }
  },

  methods: {
    async deleteWebsite (website) {
      await this.$root.$confirm('Verwijderen', 'Weet je zeker dat je dit websiteprofiel permanent wil verwijderen?', { color: 'red', confirmLabel: 'Verwijderen' })

      this.isLoading = true

      await this.$store.dispatch('graphqlMutation', {
        name: 'deleteWebsite',
        variables: {
          id: website.id
        },
        deleteCacheQueries: ['getWebsites', 'getWebsitesWithDealerInfo']
      })

      this.websites.splice(this.websites.findIndex(x => x.id === website.id), 1)

      this.isLoading = false

      this.$root.$snackbar.show('Websiteprofiel verwijderd')
    }
  },

  watch: {
    value (v) {
      this.websites = v
    },

    loading (v) {
      this.isLoading = v
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
